/*
 * Copyright (c) 2025 Frayo and HomeChef360. All Rights Reserved.
 *
 * CONFIDENTIAL & PROPRIETARY
 * This software and its source code are the confidential and proprietary
 * information of Frayo and HomeChef360. Unauthorized copying, modification,
 * distribution, disclosure, or use of this code, in whole or in part, via any
 * medium, is strictly prohibited without prior written consent.
 *
 * Violations will be subject to legal action in the State of Florida and may
 * also be pursued under applicable U.S. federal law.
 */

import { useEffect, useState } from "react";
import "../../../assets/styles//custom-style.css";

import { useAuth } from "../../../auth";
import "../../../assets/styles/custom-style.scss";
import {
  listBankData,
  listChefSettlement,
  listWalletAmount,
} from "../core/_requests";

import { Link, useNavigate } from "react-router-dom";
import { UUID } from "crypto";
import Pagination from "../../../component/Pagination";
import { useFormattedUtils } from "../../../component/dateUtils";

const ViewSettlements = () => {
  const { formatDateUS } = useFormattedUtils();
  const navigate = useNavigate();
  const { currentUser } = useAuth();

  const [wallet, setWallet] = useState<any[]>([]); // Initialize with an empty array
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const chefId = currentUser?.uuid;
  //pagination
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  const filterData = {
    search: search,
  };

  useEffect(() => {
    listChefSettlement(chefId).then((res) => {
      setWallet(res?.data); // Set wallet state with data from the response or an empty array
    });
  }, []);

  const AddSettlements = () => {
    navigate("/settlements/add");
  };
  const EditSettlements = (primaryId: string) => {
    navigate("/settlements/edit/" + primaryId);
  };

  const deleteSettlements = (primaryId: string) => {
    navigate("/settlements/delete/" + primaryId);
  };

  //pagination

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = wallet.slice(indexOfFirstItem, indexOfLastItem);
  const pages = Math.ceil(wallet.length / itemsPerPage);

  const pageNumbers = [];
  for (let i = 1; i <= pages; i++) {
    pageNumbers.push(i);
  }
  const renderPageNumbers = pageNumbers.map((number) => {
    const isActive = number === currentPage;

    let pageNumberContent;

    if (
      number === 1 ||
      number === pages ||
      (number >= currentPage - 1 && number <= currentPage + 1)
    ) {
      pageNumberContent = (
        <li
          key={number}
          className={`page-item ${number === currentPage ? "active" : ""}`}
        >
          <a
            className={`page-link cursorPointer ${number === currentPage ? "active" : ""
              }`}
            onClick={() => setCurrentPage(number)}
          >
            {number}
          </a>
        </li>
      );
    } else if (number === 2 || number === pages - 1) {
      // Add links for second and second-to-last pages
      pageNumberContent = (
        <li key={number} className="page-item">
          <a
            className="page-link cursorPointer"
            onClick={() => setCurrentPage(number)}
          >
            {number}
          </a>
        </li>
      );
    } else if (number === 3 && currentPage > 4) {
      // Add ellipsis before the link to the second page
      pageNumberContent = (
        <li key={number} className="page-item">
          <span className="ellipsis">...</span>
        </li>
      );
    } else if (number === pages - 2 && currentPage < pages - 3) {
      // Add ellipsis before the link to the second-to-last page
      pageNumberContent = (
        <li key={number} className="page-item">
          <span className="ellipsis">...</span>
        </li>
      );
    }

    return pageNumberContent;
  });

  const nextPage = () => {
    if (currentPage < pages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const prevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };
  const listTransaction = () => {
    navigate("/settlements/all-settlement");
  };

  return (
    <>
      <section className="container-fluid">
        <div className="row">
          <section className="content-section">
            {/*  */}
            <section className="row main-content settlement-content">
              {/* <div className="title mb-3 d-flex align-items-center justify-content-between">
                <h3 className="mb-0">Settlement</h3>
                <button className="btn btn-primary btn-ico rounded-5 btn-empty small" onClick={listTransaction}>
                  <i className="material-symbols-outlined">history</i>
                  <span>Transaction History</span>
                </button>
              </div> */}

              <div className="col-12">
                <div className="row">
                  <div className="col-12 mt-4 mb-4">
                    <div className="snippet-block">
                      <div className="head">
                        <h6 className="mb-0">Settlement List</h6>
                      </div>
                      {/* Check if wallet array is empty */}
                      {wallet.length === 0 ? (
                        <div className="snippet-content">
                          <div className="no-data">
                            <img
                              className="img-fluid mb-3"
                              src="/assets/images/no-data-img.svg"
                              alt="No Data"
                            />
                            <p className="mb-0 mid-gray">
                              <small>
                                 No Funds Settled Yet – Check Back Soon!
                              </small>
                            </p>
                          </div>
                        </div>
                      ) : (
                        <div className="snippet-content">
                          <table className="table custom-table mb-0">
                            <thead>
                              <tr>
                                <th>S.No</th>
                                <th>Settlement Id</th>
                                <th>Date</th>
                                <th>Amount ($)</th>
                              </tr>
                            </thead>
                            <tbody>
                              {currentItems.map(
                                (walletDetail: any, index: any) => (
                                  <tr key={index}>
                                    <td>{indexOfFirstItem + index + 1}</td>
                                    <td>
                                      {" "}
                                      <Link
                                        to={`/settlements/settlement-details/${walletDetail.primaryId}`}
                                        className="text-decoration-none"
                                      >
                                        {walletDetail.settlementId}{" "}
                                      </Link>
                                    </td>
                                    <td>{formatDateUS(walletDetail.date)}</td>
                                    <td>
  {walletDetail.amount !== undefined && walletDetail.amount !== null
    ? `$ ${walletDetail.amount.toFixed(2)}`
    : "-"}
</td>

                                  </tr>
                                )
                              )}
                            </tbody>
                          </table>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <Pagination
                data={wallet}
                indexOfFirstItem={indexOfFirstItem}
                indexOfLastItem={indexOfLastItem}
                currentItems={currentItems}
                pages={pages}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                pageNumbers={pageNumbers}
                itemsPerPage={itemsPerPage}
                setItemsPerPage={setItemsPerPage}
              />
            </section>
          </section>
        </div>
      </section>
    </>
  );
};

export default ViewSettlements;
